// app/src/utils/brazeCart.ts
import { unwindEdges } from '@good-idea/unwind-edges'
import { ShopifyStorefrontCart } from '../types/generated-shopify'

const formatPrice = (amount: string | number, currencyCode: string = 'USD') => {
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount
  const lang =
    typeof navigator !== 'undefined' ? navigator.language ?? 'en-US' : 'en-US'

  return new Intl.NumberFormat(lang, {
    style: 'currency',
    currency: currencyCode,
  }).format(numAmount)
}

export async function updateCartSnapshotInBraze(cart: ShopifyStorefrontCart) {
  if (typeof window === 'undefined' || !cart) return

  const enrichedCartSnapshot = unwindEdges(cart.lines)[0].map((line) => {
    const variant = line.merchandise
    const product = variant?.product

    const addWidthParam = (url: string) => {
      const separator = url.includes('?') ? '&' : '?'
      return `${url}${separator}width=300`
    }

    const variantImageUrl = variant?.image?.originalSrc
      ? addWidthParam(variant.image.originalSrc)
      : null
    const productImageUrl = product?.images?.edges?.[0]?.node?.originalSrc
      ? addWidthParam(product.images.edges[0].node.originalSrc)
      : null

    console.log('variant', variant)
    console.log('product', product)
    const brazeCartItem = {
      variant_id: variant?.id?.split('/').pop(),
      title: variant?.title,
      product_title: product?.title,
      image_url: variantImageUrl || productImageUrl,
      price: formatPrice(
        variant?.priceV2?.amount || '0',
        variant?.priceV2?.currencyCode || 'USD',
      ),
      variant_url: `https://spinellikilcollin.com/products/${
        product?.handle
      }?v=${btoa(variant?.id)}`,
    }
    console.log('brazeCartItem', brazeCartItem)
    return brazeCartItem
  })

  const { getUser } = await import('./braze-exports')
  try {
    getUser()?.setCustomUserAttribute('cart_snapshot', enrichedCartSnapshot)
    // Optionally log success
    console.log(
      '[Braze] Successfully set cart_snapshot in Braze:',
      enrichedCartSnapshot,
    )
  } catch (err) {
    // Optionally log error
    console.error('[Braze] Failed to set cart_snapshot in Braze:', err)
  }
}
